module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Create new customer"},"et":{"title":"Create new customer"},"ru":{"title":"Create new customer"}}')
  delete Component.options._Ctor
}
